import { InviteAcceptanceLeftSide } from "./left-side/left-side";
import { HpInviteHandoff } from "./hp-invite-handoff";
import { InviteSplash } from "./invite-splash";
import { useStyle } from "./style";
import { useEffect } from "react";
import { useCompanyProfile } from "@/hooks/use-company-profile";
import { LoginRightSide } from "../login/right-side/right-side";
import { HP_CLIENT_THEME, useTheme } from "@/contexts/theme";

interface InviteAcceptanceWidgetProps {
  /** From getServerSideProps when PrintHouses.Theme is hp-client (or TenantId is set). */
  isHpInvite?: boolean;
}

const InviteAcceptanceWidget = ({
  isHpInvite,
}: InviteAcceptanceWidgetProps) => {
  const { clasess } = useStyle();
  const { getCompanyLogo } = useCompanyProfile();
  const { currentTheme, isLoading: isThemeLoading } = useTheme();

  // The server already answered for the HP case; otherwise the theme context resolves the
  // same PrintHouses.Theme / TenantId on the client (localhost, shared login host, API hiccup).
  const isBrandResolved = !!isHpInvite || !isThemeLoading;
  const isHp = !!isHpInvite || currentTheme === HP_CLIENT_THEME;

  useEffect(() => {
    if (isHp || !isBrandResolved) return;
    getCompanyLogo().then();
  }, [isHp, isBrandResolved]);

  if (isHp) {
    return <HpInviteHandoff />;
  }

  // Render nothing brand-specific until the print house is known, so HP invitees are not
  // shown the GoMake-themed provider picker for a moment before the handoff.
  if (!isBrandResolved) {
    return <InviteSplash />;
  }

  return (
    <div style={clasess.container}>
      <InviteAcceptanceLeftSide />
      <LoginRightSide />
    </div>
  );
};
export { InviteAcceptanceWidget };
